import { Component, Input, OnInit } from '@angular/core';
import { WineRegion } from 'app/services/interfaces/region';

@Component({
  selector: 'app-wine-region-card',
  templateUrl: './wine-region-card.component.html',
  styleUrl: './wine-region-card.component.scss'
})
export class WineRegionCardComponent implements OnInit{

  navigateToRegion() {
  throw new Error('Method not implemented.');
  }
  @Input() wineRegion?: WineRegion;

  ngOnInit(): void {}
}
